<template>
  <div class="client-grouping-pane">
    <div class="search ctp-direct-search" style="padding-top: 0">
      <el-button
        class="client-eval-add-btn"
        icon="el-icon-plus"
        type="primary"
        @click="$emit('open-add')"
        >添加</el-button
      >
      <el-input
        v-model="searchName"
        class="ctp-direct-search__field"
        placeholder="账户组名称"
        clearable
        autocomplete="off"
        @keyup.enter.native="runSearch"
      />
      <div>
        <input
          class="btn"
          type="button"
          style="background-color: #5b85ff; color: #fff"
          value="搜索"
          @click="runSearch"
        />
        <input
          class="btn"
          type="reset"
          style="margin-right: 0"
          value="重置"
          @click.prevent="resetLocal"
        />
      </div>
    </div>
    <div class="table client-grouping-grouped-table">
      <el-table
        :data="tableRows"
        :span-method="groupSpanMethod"
        border
        size="small"
        style="width: 100%"
      >
        <el-table-column
          prop="groupName"
          label="账户组名称"
          min-width="110"
          align="center"
        />
        <el-table-column prop="userCode" label="登录账户" min-width="100" />
        <el-table-column prop="userName" label="登录姓名" min-width="120" />
        <el-table-column
          prop="accountType"
          label="账户类型"
          min-width="110"
          align="center"
        />
        <el-table-column
          prop="multiple"
          label="交易倍率"
          width="100"
          align="center"
        />
        <el-table-column
          label="绑定交易账户"
          width="130"
          align="center"
        >
          <template slot-scope="scope">
            <span
              class="iconfont icon-bianji client-grouping-row-action"
              style="font-size: 14px;"
              title="绑定交易账户"
              @click="onBindGroup(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="编辑" width="80" align="center">
          <template slot-scope="scope">
            <span
              class="iconfont icon-xiugai client-grouping-row-action"
              title="编辑"
              @click="onEditGroup(scope.row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="删除" width="80" align="center">
          <template slot-scope="scope">
            <span
              class="iconfont icon-shanchu client-grouping-row-action"
              title="删除"
              @click="onDeleteGroup(scope.row)"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
/** 已分组列表：搜索、编辑组名、绑定账户、删除组 */
import '@/view/user/eval_jees/style.css';
import { groupingAccountTypeLabel } from './groupingAccountType';

function multipleDisplay(acc) {
  if (acc == null) {
    return '—';
  }
  const v = acc.multiple;
  if (v === undefined || v === null || v === '') {
    return '—';
  }
  return v;
}

/** 与旧版 group_list 等接口对齐：列表可能在 data、datas、list */
function extractGroupListArray(resBody) {
  if (!resBody || typeof resBody !== 'object') {
    return [];
  }
  const candidates = [
    resBody.data,
    resBody.datas,
    resBody.list,
    resBody.records,
  ];
  for (let i = 0; i < candidates.length; i++) {
    const v = candidates[i];
    if (Array.isArray(v)) {
      return v;
    }
  }
  const nested = resBody.data;
  if (nested && typeof nested === 'object' && !Array.isArray(nested)) {
    if (Array.isArray(nested.list)) {
      return nested.list;
    }
    if (Array.isArray(nested.records)) {
      return nested.records;
    }
    if (Array.isArray(nested.datas)) {
      return nested.datas;
    }
  }
  return [];
}

function getGroupAccounts(g) {
  if (!g || typeof g !== 'object') {
    return [];
  }
  if (Array.isArray(g.evalJees)) {
    return g.evalJees;
  }
  if (Array.isArray(g.eval_jees)) {
    return g.eval_jees;
  }
  return [];
}

/**
 * 接口 /api_eval/direct_group_list：分组项含 id、name、evalJees（或 eval_jees）
 * 表格对「分组名称」与后三列操作做纵向合并
 */
function flattenGroupsFromApi(apiGroups) {
  const rows = [];
  (apiGroups || []).forEach((g) => {
    const groupId = g.id != null ? g.id : g.groupId;
    const groupName = g.name != null ? String(g.name) : '';
    const accounts = getGroupAccounts(g);
    if (accounts.length === 0) {
      rows.push({
        groupId,
        groupName,
        userCode: '—',
        userName: '—',
        accountType: '—',
        multiple: '—',
        _groupRowspan: 1,
        _isFirstInGroup: true,
      });
      return;
    }
    const len = accounts.length;
    accounts.forEach((acc, idx) => {
      rows.push({
        groupId,
        groupName,
        userCode: acc.userCode != null ? String(acc.userCode) : '—',
        userName: acc.userName != null ? String(acc.userName) : '—',
        accountType: groupingAccountTypeLabel(acc),
        multiple: multipleDisplay(acc),
        _groupRowspan: len,
        _isFirstInGroup: idx === 0,
      });
    });
  });
  return rows;
}

export default {
  name: 'ClientGroupingGroupedList',
  data() {
    return {
      tableRows: [],
      /** 按分组名称筛选，请求体字段 name */
      searchName: '',
    };
  },
  mounted() {
    this.loadGroupList();
  },
  methods: {
    apiToken() {
      try {
        const t = JSON.parse(localStorage.getItem('token') || '{}');
        return t.apiToken || this.$store.state.usermsg.apiToken;
      } catch (e) {
        return this.$store.state.usermsg.apiToken;
      }
    },
    /** 供父级在添加分组成功后刷新 */
    loadGroupList() {
      return this.$request
        .post('/api_eval/direct_group_list', {
          token: this.apiToken(),
          name: String(this.searchName || '').trim(),
        }, { skipToken: true, rawResponse: true })
        .then((res) => {
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            const list = extractGroupListArray(res.data);
            this.tableRows = flattenGroupsFromApi(list);
          } else {
            this.tableRows = [];
            const msg =
              (res.data && (res.data.message || res.data.msg)) || '加载失败';
            this.$message.error(msg);
          }
        })
        .catch(() => {
          this.tableRows = [];
          this.$message.error('网络异常，请稍后重试');
        });
    },
    runSearch() {
      this.loadGroupList();
    },
    resetLocal() {
      this.searchName = '';
      this.loadGroupList();
    },
    /** 第 0 列与第 5–7 列按组合并；中间账号相关列每行独立 */
    groupSpanMethod({ row, columnIndex }) {
      const mergeColIndexes = [0, 5, 6, 7];
      if (!mergeColIndexes.includes(columnIndex)) {
        return { rowspan: 1, colspan: 1 };
      }
      if (row._isFirstInGroup) {
        return { rowspan: row._groupRowspan, colspan: 1 };
      }
      return { rowspan: 0, colspan: 0 };
    },
    onBindGroup(row) {
      if (row.groupId == null) {
        return;
      }
      this.$emit('open-bind', {
        groupId: row.groupId,
        groupName: row.groupName || '',
      });
    },
    onEditGroup(row) {
      if (row.groupId == null) {
        return;
      }
      this.$emit('open-edit', {
        groupId: row.groupId,
        groupName: row.groupName || '',
      });
    },
    onDeleteGroup(row) {
      if (row.groupId == null) {
        return;
      }
      const name = row.groupName || '该账户组';
      this.$confirm(`您确定要删除账户组「${name}」吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          this.$request
            .post('/api_eval/group_del', {
              token: this.apiToken(),
              id: row.groupId,
            }, { skipToken: true, rawResponse: true })
            .then((res) => {
              this.tokenInvalid(res);
              if (res.data.code == 200) {
                this.$message.success('删除成功');
                this.loadGroupList();
              } else {
                this.$alert(
                  (res.data && (res.data.message || res.data.msg)) ||
                    '删除失败',
                  {
                    confirmButtonText: '确定',
                    type: 'error',
                    center: true,
                  }
                );
              }
            })
            .catch(() => {
              this.$message.error('网络异常，请稍后重试');
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.client-grouping-row-action {
  cursor: pointer;
  color: #5b85ff;
  font-size: 18px;
  vertical-align: middle;
}

.client-grouping-row-action:hover {
  opacity: 0.85;
}

/* 与 CtpDirectAccountList 搜索区 el-input / el-select 一致（scoped + >>> 穿透子组件） */
.ctp-direct-search {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
}
.ctp-direct-search >>> .ctp-direct-search__field {
  width: 170px;
}
.ctp-direct-search >>> .ctp-direct-search__field .el-input__inner {
  height: 34px;
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/view/client/grouping/GroupedList.vue